function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { NjcSwitch as d } from "../switch.js";
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as h } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as g } from "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as n } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import u from "../../../packages/web-components/src/components/switch/switch.tokens.scss.js";
import p from "../../../packages/web-components/src/components/switch/gator/switch.gator.scss.js";
import { unsafeCSS as r } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var w = Object.getOwnPropertyDescriptor,
  v = function v(t, s, c, a) {
    for (var e = a > 1 ? void 0 : a ? w(s, c) : s, o = t.length - 1, l; o >= 0; o--) (l = t[o]) && (e = l(e) || e);
    return e;
  };
var i = /*#__PURE__*/function (_d) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i), _this.addEventListener("click", _this.handleClick);
    return _this;
  }
  _inherits(i, _d);
  return _createClass(i, [{
    key: "updated",
    value: function updated() {
      var s;
      var t = (s = this.shadowRoot) == null ? void 0 : s.querySelector(".gator-switch");
      t == null || t.classList.toggle("gator-switch-on", this.value), t == null || t.classList.toggle("gator-switch-disabled", this.disabled);
    }
  }, {
    key: "render",
    value: function render() {
      return h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<div class=\"gator-switch-container\">\n\t\t\t\t<div id=\"", "\" class=\"gator-switch\">\n\t\t\t\t\t<input id=\"", "\" role=\"switch\" type=\"checkbox\" .checked=\"", "\" .disabled=\"", "\" @keydown=\"", "\" @click=", " />\n\t\t\t\t\t<div class=\"gator-switch-slider\"></div>\n\t\t\t\t</div>\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"])), this._getContainerId(), this._getInputId(), this.value, this.disabled, this.handleInputKeydown, this.handleInputClick, this.label ? this._getLabelMarkup() : "");
    }
  }, {
    key: "handleInputKeydown",
    value: function handleInputKeydown(t) {
      t.key === " " && (t.preventDefault(), this._toggleSwitch());
    }
  }, {
    key: "handleInputClick",
    value: function handleInputClick(t) {
      t.stopImmediatePropagation();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this._toggleSwitch();
    }
  }, {
    key: "_toggleSwitch",
    value: function _toggleSwitch() {
      var t;
      if (!this.disabled) {
        this.value = !this.value;
        var s = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".gator-switch");
        s == null || s.classList.toggle("gator-switch-toggle-on", this.value), s == null || s.classList.toggle("gator-switch-toggle-off", !this.value), this.dispatchEvent(new CustomEvent("change", {
          detail: this.value,
          bubbles: !0
        }));
      }
    }
  }, {
    key: "_getLabelMarkup",
    value: function _getLabelMarkup() {
      return h(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<label for=\"", "\">", "</label>"])), this._getInputId(), this.label);
    }
  }, {
    key: "_getInputId",
    value: function _getInputId() {
      return "".concat(this.getElementId(), "-input");
    }
  }, {
    key: "_getContainerId",
    value: function _getContainerId() {
      return "".concat(this.getElementId(), "-container");
    }
  }]);
}(d);
i.shadowRootOptions = _objectSpread(_objectSpread({}, g.shadowRootOptions), {}, {
  delegatesFocus: !0
});
i.styles = [r(u), r(p)];
i = v([n("ngc-switch")], i);
export { i as NgcSwitch };